import { render, staticRenderFns } from "./download-mpp-modal.vue?vue&type=template&id=36028f6a"
import script from "./download-mpp-modal.vue?vue&type=script&lang=js"
export * from "./download-mpp-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports